// Tiny, dependency-free home for the demo's numeric limits. Kept separate from
// demoEntitlements.js (which imports the full EXAMPLE_EMPLOYEES census array) so
// the public landing page can show these numbers without bundling that array.
//
// EXAMPLE_EMPLOYEE_COUNT is a hand-maintained literal; the test in
// test/example-employee-count.test.js asserts it matches EXAMPLE_EMPLOYEES.length.
// The demo supports a full census. This remains exported for backward
// compatibility with the demo entitlement helpers, but no longer caps users.
export const DEMO_EMPLOYEE_LIMIT = Number.POSITIVE_INFINITY
export const EXAMPLE_EMPLOYEE_COUNT = 100
